import { Skeleton } from '@/ui/components/skeleton/skeleton';

import { PlotSection } from '../plot-section';

export type SectionSkeletonProps = {
  sectionName: string;
};
export function SectionSkeleton({ sectionName }: SectionSkeletonProps) {
  return (
    <PlotSection sectionName={sectionName}>
      {/* Simulate the disclosure title or section name */}
      <Skeleton className="mb-4 h-5 w-1/3" />
      <div className="flex flex-col gap-y-6">
        {/* Chart placeholders */}
        <Skeleton className="h-[400px]" />
      </div>
    </PlotSection>
  );
}
